
import { Vue, Options } from "vue-class-component";
import { Http, ResponseData } from "../../net/Http";
import { Urls } from "../../net/Urls";
import { MyLuckyCodes } from "../../model/lottery/LotteryModel";
import Nav from "../../components/nav/Nav.vue";

@Options({
  components: { Nav }
})
export default class MyLuck extends Vue {
  luckyCodes: MyLuckyCodes[] = [];
  isLoading = true;
  mounted() {
    this.initData();
  }
  initData() {
    this.isLoading = true;
    Http.post<MyLuckyCodes[]>(Urls.lottery_getMyLuckyCodes, null).then(
      (res: MyLuckyCodes[]) => {
        this.isLoading = false;
        this.luckyCodes = res;
      },
      (err: ResponseData) => {
        this.isLoading = false;
        console.log(Urls.lottery_getMyLuckyCodes, err.message);
        // openToast(err.message);
      }
    );
  }
  exchange() {
    this.$router.back();
  }
}
